import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { WizardViewComponent } from './wizard-view.component';

export const ngxWizardViewModule = angular.module('ngxWizardViewModule', [])
	.directive('ngxWizardView', downgradeComponent({ component: WizardViewComponent }))
	.name;
